module.exports = __webpack_public_path__ + "img/2_123.680914bd.png";